import { useParams } from "react-router-dom";

import { FlexPackDashboardWrapper } from "../../components";

export default function FlexPackDashboardPage() {
  let { uuid } = useParams();

  return (
    <>
      <FlexPackDashboardWrapper flexPackId={uuid} />
    </>
  );
}
